/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_Title_HintInputs */

const vi_shop_home_hero_title_hint = /** @type {(inputs: Shop_Home_Hero_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được xuống dòng.`)
};

/**

* @param {Shop_Home_Hero_Title_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_title_hint = /** @type {((inputs?: Shop_Home_Hero_Title_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_Title_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_title_hint(inputs)
});